import React, { useRef, useEffect } from 'react';

import { bemCssModules } from '@utils';
import i18n, { LanguageType } from '@utils/i18n';

import { globalActions, useStore } from '@modules';

import Dropdown from '@components/Dropdown';
import Icon from '@components/Icon';

import style from './LangSwitcher.scss';

const cn = bemCssModules(style, 'LangSwitcher');

export const LangSwitcher: CustomFC = ({ className }) => {
  const [{ global }, dispatch] = useStore();
  const { lang } = global;
  const langs = Object.keys(CONST.i18n.languages) as LanguageType[];
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    // fix first detecting language by LanguageDetector
    const short = i18n.language?.split('-')[0] as LanguageType;
    if (lang !== short) dispatch(globalActions.setLang(short));
  }, []);

  const onChange = (language: LanguageType) => {
    if (language !== lang) dispatch(globalActions.setLang(language));
  };

  return (
    <div className={cn(null, [className])}>
      <button className={cn('value', ['link'])} ref={buttonRef} type="button">
        {lang}
        <Icon name="arrow_down" className={cn('icon')} size={7} />
      </button>
      <div className={cn('modal-wrapper')}>
        <Dropdown
          className={cn('modal')}
          data={langs}
          controller={buttonRef}
          value={lang}
          onChange={onChange}
          classNames={{ defaultOption: cn('default-option') }}
          customLabel={langTitle => CONST.i18n.languages[langTitle].name}
        />
      </div>
    </div>
  );
};

export default LangSwitcher;
